export default "__VITE_ASSET__BU4aw80I__"